import React from 'react'
import { connect } from 'react-redux'

import ChannelsCreate from 'screens/ChannelsCreate'
import ChannelClone from 'components/CloneChannel'
import ChannelsSettings from 'components/Channels/Settings'
import MoveTo from 'screens/MoveTo'
import NotesHistory from 'components/NotesHistory'
import NotesInfos from 'components/NotesInfos'
import ChannelOnboarding from 'components/ChannelOnboarding'
import NotesShareToSlack from 'components/Notes/ShareToSlack'
import SlackInvite from 'components/Invitations/SlackInvite'
import InviteOauthMembers from 'components/InviteOauthMembers'
import ImportFiles from 'components/ImportFiles'
import FileLimitExceeded from 'components/Limits/FileLimitExceeded'
import ShortcutsModal from 'screens/Shortcuts'
import DesktopAppRedirectionModal from 'screens/DesktopAppRedirection'
import NotificationCenter from 'screens/NotificationsCenter'
import TemplatePicker from 'screens/TemplatesPicker'

import { getActiveModal } from 'data/ui/selectors'
import { closeActiveModal } from 'data/ui/actions'
import { isInviteOnboardingStep } from 'data/userPreferences/selectors'
import { canCurrentUserInviteMembers, getAllUsers } from 'data/users/selectors'
import {
  goToAppropriateUserOnboardingStep,
  goToUserOnboardingStep,
} from 'data/onboarding/actions'
import { setActiveModal } from 'data/ui/actions'
import * as modalIds from './constants'
import Wrapper from './Wrapper'
import { IncentiveModalContent } from '../../../screens/Sidebar/NewSidebar/ContextualNewNoteButton/IncentiveModalContent'

const enhance = connect(
  state => ({
    activeModal: getActiveModal(state),
    isInviteOnboardingStep: isInviteOnboardingStep(state),
    canUserInvite: canCurrentUserInviteMembers(state),
    usersCount: getAllUsers(state, {
      filterOutArchived: true,
      filterOutInvited: true,
    }).size,
  }),
  {
    goToAppropriateUserOnboardingStep,
    setActiveModal,
    closeActiveModal,
    goToUserOnboardingStep,
  }
)

class ModalContainer extends React.Component {
  componentDidMount() {
    const {
      isInviteOnboardingStep,
      canUserInvite,
      goToUserOnboardingStep,
      usersCount,
    } = this.props
    if (isInviteOnboardingStep) {
      if (canUserInvite && usersCount < 10) {
        this.props.setActiveModal({
          id: modalIds.INVITE_OAUTH_MEMBERS,
        })
      } else {
        goToUserOnboardingStep({ step: 'channels' })
      }
    }
  }
  render() {
    const { activeModal } = this.props
    if (!activeModal) {
      return false
    }

    const { id: activeModalId, meta } = activeModal
    let InnerComponent = false
    let wide = false
    let auto = false
    let size = undefined
    let onClose = () => {}
    let center = false
    let fullScreenModal = false
    let fullScreenModalCloseIcon = false
    let fullScreenModalLogo = false
    switch (activeModalId) {
      case modalIds.CHANNEL_CREATE:
        InnerComponent = ChannelsCreate
        fullScreenModal = true
        fullScreenModalCloseIcon = true
        break
      case modalIds.NOTIFICATIONS_CENTER:
        InnerComponent = NotificationCenter
        break
      case modalIds.CHANNEL_CLONE:
        InnerComponent = ChannelClone
        break
      case modalIds.CHANNEL_SETTINGS:
        InnerComponent = ChannelsSettings
        wide = true
        break
      case modalIds.MOVE_TO:
        InnerComponent = MoveTo
        break
      case modalIds.NOTES_HISTORY:
        InnerComponent = NotesHistory
        auto = true
        break
      case modalIds.NOTES_INFOS:
        InnerComponent = NotesInfos
        break
      case modalIds.NOTES_SHARE_TO_SLACK:
        InnerComponent = NotesShareToSlack
        break
      case modalIds.TEMPLATE_PICKER:
        InnerComponent = TemplatePicker
        break
      case modalIds.SLACK_INVITE:
        InnerComponent = SlackInvite
        onClose = () => {
          if (this.props.isInviteOnboardingStep) {
            this.props.goToAppropriateUserOnboardingStep()
          }
        }
        break
      case modalIds.CHANNEL_ONBOARDING:
        InnerComponent = ChannelOnboarding
        break
      case modalIds.INVITE_OAUTH_MEMBERS:
        InnerComponent = InviteOauthMembers
        size = 575
        onClose = () => {
          if (this.props.isInviteOnboardingStep) {
            this.props.goToAppropriateUserOnboardingStep()
          }
        }
        break
      case modalIds.IMPORT_FILES:
        size = 600
        InnerComponent = ImportFiles
        break
      case modalIds.FILE_LIMIT_EXCEEDED:
        size = 400
        InnerComponent = FileLimitExceeded
        center = true
        break
      case modalIds.SHORTCUTS:
        InnerComponent = ShortcutsModal
        size = 960
        break
      case modalIds.DESKTOP_REDIRECTION:
        InnerComponent = DesktopAppRedirectionModal
        fullScreenModal = true
        fullScreenModalLogo = true
        break
      case modalIds.PAYMENT_INCENTIVE:
        InnerComponent = IncentiveModalContent
        size = 400
        break
      default:
        center = true
        size = meta.size
        InnerComponent = meta.innerComponent
    }
    return (
      <Wrapper
        wide={wide}
        auto={auto}
        size={size}
        onClose={onClose}
        center={center}
        fullScreenModal={fullScreenModal}
        fullScreenModalCloseIcon={fullScreenModalCloseIcon}
        fullScreenModalLogo={fullScreenModalLogo}
      >
        <InnerComponent {...meta} closeModal={this.props.closeActiveModal} />
      </Wrapper>
    )
  }
}

export default enhance(ModalContainer)
